/**
 * Logout (placeholder)
 *
 * Will eventually hit /api/admin/logout and redirect to /Admin/Login.
 * For now, just renders a placeholder so imports resolve.
 */
const Logout = () => {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold">Logout</h1>
      <p className="text-sm text-neutral-600 mt-2">Logout page (placeholder)</p>
    </div>
  );
};

export default Logout;